module.exports = __webpack_public_path__ + "static/4i-64dedff6e34dcd5ee10c154ca035167b.woff";